import { Button, Center, Container, Group, Stack, Text, Title } from "@mantine/core";

export default function PageNotFound() {
  return (
    <Container>
      <Center mt="20vh">
        <Stack gap="xl">
          <Stack gap="xs">
            <Title>Not found</Title>
            <Text size="lg">The page or content you are looking for does not exist.</Text>
          </Stack>
          <Group gap="xs">
            <Button variant="light" onClick={() => (document.location.href = "/")} maw="200">
              Go to Home
            </Button>
            <Button variant="light" onClick={() => document.location.reload()} maw="200">
              Try again
            </Button>
          </Group>
        </Stack>
      </Center>
    </Container>
  );
}
